import React from 'react';

import { InternetBanner, SearchTravel } from '@/ui/index';

import { Tariffs } from '../../home';

const PricesAndCountries = ({ data }) => {
  return (
    <div itemScope itemType='http://schema.org/Offer'>
      {data?.mainBanner && <InternetBanner bannerData={data.mainBanner} />}
      {data?.travel && <SearchTravel travelData={data.travel} />}
      {data?.offers && (
        <Tariffs
          tabs={data.offers}
          title={'Recommended tariffs'}
          buttonText={'Archive'}
        />
      )}
    </div>
  );
};

export default PricesAndCountries;
